export const APP_VERSION_MUTATION_SUCCESS_EVENT = 'app-version-mutation-success';
